@if (currentUser.uninitialized) {
  <div class="loading-tip">
    <div class="ui placeholder">
      <div class="line"></div>
      <div class="line"></div>
    </div>
  </div>
}
@if (!currentUser.uninitialized && currentUser.type === eUserAccountType.Anonymous) {
  <a routerLink="/login" class="ui button basic">Sign In</a>
}
@if (!currentUser.uninitialized && currentUser.type !== eUserAccountType.Anonymous) {
  <div class="user-action" #userActionLink>
    <div class="text">{{currentUser.name}} @if (!currentUser.verified) {
      <span>(unverified)</span>
    }</div>
  </div>
}
